import * as React from 'react'
import { cn } from '~/shared/lib/cn'

interface TextareaProps extends React.ComponentProps<'textarea'> {
  filled?: boolean
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, filled, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'border-input-outlined-enabled-border placeholder:text-text-tertiary focus-visible:border-input-outlined-focused-border disabled:border-input-outlined-disabled-border hover:border-input-outlined-hovered-border box-border flex min-h-[60px] w-full rounded-lg border bg-transparent p-3 text-[12px] leading-4 tracking-[0.4px] outline-none disabled:cursor-not-allowed',
          className,
          {
            'bg-surface-low border-none': filled,
          },
        )}
        ref={ref}
        {...props}
      />
    )
  },
)
Textarea.displayName = 'Textarea'

export { Textarea }
